import styled from "styled-components";

const ProductListSession = styled.div`
    margin-bottom: 16px;
    border-bottom: 1px solid #e6e5e5;

    .list-main {
        .list-main-inner {
            max-height: 400px;
            overflow: auto;
            padding-right: 5px;
        }
    }
`;
export default ProductListSession;
